class Crossplay {
  constructor(platform) {
    this.platform = platform;
  }
  getCrossplayPayload(eventProps) {
    return {
      isAppSwitch: true,
      crossplayTracking: eventProps
    };
  }
  isCrossplayEntry() {
    return !!this.platform.entryData.isAppSwitch;
  }
}
export {
  Crossplay
};
